import { render, staticRenderFns } from "./ListMADDs.vue?vue&type=template&id=8e8eba4a"
import script from "./ListMADDs.vue?vue&type=script&lang=js"
export * from "./ListMADDs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e8eba4a')) {
      api.createRecord('8e8eba4a', component.options)
    } else {
      api.reload('8e8eba4a', component.options)
    }
    module.hot.accept("./ListMADDs.vue?vue&type=template&id=8e8eba4a", function () {
      api.rerender('8e8eba4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ListMADDs.vue"
export default component.exports